// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.display-steuerung {
    max-width: 800px;
    margin: 0 auto;
}

.display-steuerung .description {
    color: #666;
    margin-bottom: 1.5rem;
}

.settings-card {
    background: white;
    border-radius: 12px;
    padding: 1.5rem;
    margin-bottom: 1rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.settings-card h4 {
    margin: 0 0 1rem 0;
    color: #333;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.mode-toggle {
    display: flex;
    gap: 1rem;
    margin-bottom: 1rem;
}

.mode-btn {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 1rem;
    border: 2px solid #ddd;
    border-radius: 8px;
    background: white;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 1rem;
    color: #666;
}

.mode-btn:hover {
    border-color: #f1a93a;
    color: #f1a93a;
}

.mode-btn.active {
    border-color: #f1a93a;
    background: linear-gradient(135deg, #f1a93a 0%, #e8941a 100%);
    color: white;
}

.mode-btn .material-symbols-outlined {
    font-size: 1.5rem;
}

.mode-description {
    color: #888;
    font-size: 0.9rem;
    margin: 0;
    padding: 0.75rem;
    background: #f9f9f9;
    border-radius: 6px;
}

.einheit-select {
    width: 100%;
    padding: 0.75rem 1rem;
    font-size: 1rem;
    border: 2px solid #ddd;
    border-radius: 8px;
    background: white;
    cursor: pointer;
}

.einheit-select:focus {
    outline: none;
    border-color: #f1a93a;
}

.selected-info {
    margin-top: 1rem;
    padding: 0.75rem;
    background: #e8f5e9;
    border-radius: 6px;
    color: #2e7d32;
}

.preview-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
}

.preview-card h4 {
    color: white;
}

.preview-link {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.5rem;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    color: white;
    text-decoration: none;
    transition: background 0.2s;
}

.preview-link:hover {
    background: rgba(255, 255, 255, 0.3);
}

.preview-hint {
    margin: 1rem 0 0 0;
    font-size: 0.9rem;
    opacity: 0.8;
}

.current-status {
    background: #f5f5f5;
    border-radius: 12px;
    padding: 1.5rem;
    margin-top: 1rem;
}

.current-status h4 {
    margin: 0 0 1rem 0;
    color: #333;
}

.current-status ul {
    margin: 0;
    padding: 0;
    list-style: none;
}

.current-status li {
    padding: 0.5rem 0;
    color: #666;
}

.current-status li strong {
    color: #333;
}

.success-message {
    background: #e8f5e9;
    color: #2e7d32;
    padding: 0.75rem 1rem;
    border-radius: 8px;
    margin-bottom: 1rem;
}

.error-message {
    background: #ffebee;
    color: #c62828;
    padding: 0.75rem 1rem;
    border-radius: 8px;
    margin-bottom: 1rem;
}

@media (max-width: 600px) {
    .mode-toggle {
        flex-direction: column;
    }
}

.disabled-card {
    opacity: 0.6;
    pointer-events: none;
}

.disabled-card .mode-btn {
    pointer-events: auto;
    /* Allow clicking to enable override */
}

.reset-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    background: #4caf50;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 1rem;
    margin-top: 1rem;
    transition: background 0.2s;
}

.reset-btn:hover {
    background: #388e3c;
}

.status-display {
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
    color: #333;
}

.custom-mode-container {
    padding: 1rem;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    margin-top: 1rem;
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.input-group {
    margin-bottom: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.input-group label {
    font-weight: 500;
    color: #333;
}

.input-group input {
    padding: 0.8rem;
    border-radius: 6px;
    border: 1px solid #ddd;
    font-size: 1rem;
    font-family: inherit;
}

.save-custom-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    width: 100%;
    padding: 0.8rem;
    background: #FF9800;
    /* Orange */
    color: white;
    border: none;
    border-radius: 8px;
    font-weight: normal;
    cursor: pointer;
    font-size: 1rem;
    transition: background 0.2s;
}

.save-custom-btn:hover {
    background: #F57C00;
}

.description {
    margin-bottom: 2rem;
    color: #666;
}`, "",{"version":3,"sources":["webpack://./src/arbeit/displaysteuerung/DisplaySteuerung.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,6DAA6D;IAC7D,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf","sourcesContent":[".display-steuerung {\n    max-width: 800px;\n    margin: 0 auto;\n}\n\n.display-steuerung .description {\n    color: #666;\n    margin-bottom: 1.5rem;\n}\n\n.settings-card {\n    background: white;\n    border-radius: 12px;\n    padding: 1.5rem;\n    margin-bottom: 1rem;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.settings-card h4 {\n    margin: 0 0 1rem 0;\n    color: #333;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.mode-toggle {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 1rem;\n}\n\n.mode-btn {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    padding: 1rem;\n    border: 2px solid #ddd;\n    border-radius: 8px;\n    background: white;\n    cursor: pointer;\n    transition: all 0.2s;\n    font-size: 1rem;\n    color: #666;\n}\n\n.mode-btn:hover {\n    border-color: #f1a93a;\n    color: #f1a93a;\n}\n\n.mode-btn.active {\n    border-color: #f1a93a;\n    background: linear-gradient(135deg, #f1a93a 0%, #e8941a 100%);\n    color: white;\n}\n\n.mode-btn .material-symbols-outlined {\n    font-size: 1.5rem;\n}\n\n.mode-description {\n    color: #888;\n    font-size: 0.9rem;\n    margin: 0;\n    padding: 0.75rem;\n    background: #f9f9f9;\n    border-radius: 6px;\n}\n\n.einheit-select {\n    width: 100%;\n    padding: 0.75rem 1rem;\n    font-size: 1rem;\n    border: 2px solid #ddd;\n    border-radius: 8px;\n    background: white;\n    cursor: pointer;\n}\n\n.einheit-select:focus {\n    outline: none;\n    border-color: #f1a93a;\n}\n\n.selected-info {\n    margin-top: 1rem;\n    padding: 0.75rem;\n    background: #e8f5e9;\n    border-radius: 6px;\n    color: #2e7d32;\n}\n\n.preview-card {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n}\n\n.preview-card h4 {\n    color: white;\n}\n\n.preview-link {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1.5rem;\n    background: rgba(255, 255, 255, 0.2);\n    border-radius: 8px;\n    color: white;\n    text-decoration: none;\n    transition: background 0.2s;\n}\n\n.preview-link:hover {\n    background: rgba(255, 255, 255, 0.3);\n}\n\n.preview-hint {\n    margin: 1rem 0 0 0;\n    font-size: 0.9rem;\n    opacity: 0.8;\n}\n\n.current-status {\n    background: #f5f5f5;\n    border-radius: 12px;\n    padding: 1.5rem;\n    margin-top: 1rem;\n}\n\n.current-status h4 {\n    margin: 0 0 1rem 0;\n    color: #333;\n}\n\n.current-status ul {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n\n.current-status li {\n    padding: 0.5rem 0;\n    color: #666;\n}\n\n.current-status li strong {\n    color: #333;\n}\n\n.success-message {\n    background: #e8f5e9;\n    color: #2e7d32;\n    padding: 0.75rem 1rem;\n    border-radius: 8px;\n    margin-bottom: 1rem;\n}\n\n.error-message {\n    background: #ffebee;\n    color: #c62828;\n    padding: 0.75rem 1rem;\n    border-radius: 8px;\n    margin-bottom: 1rem;\n}\n\n@media (max-width: 600px) {\n    .mode-toggle {\n        flex-direction: column;\n    }\n}\n\n.disabled-card {\n    opacity: 0.6;\n    pointer-events: none;\n}\n\n.disabled-card .mode-btn {\n    pointer-events: auto;\n    /* Allow clicking to enable override */\n}\n\n.reset-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1rem;\n    background: #4caf50;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 1rem;\n    margin-top: 1rem;\n    transition: background 0.2s;\n}\n\n.reset-btn:hover {\n    background: #388e3c;\n}\n\n.status-display {\n    font-size: 1.1rem;\n    margin-bottom: 0.5rem;\n    color: #333;\n}\n\n.custom-mode-container {\n    padding: 1rem;\n    background: rgba(255, 255, 255, 0.1);\n    border-radius: 8px;\n    margin-top: 1rem;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.input-group {\n    margin-bottom: 1rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.input-group label {\n    font-weight: 500;\n    color: #333;\n}\n\n.input-group input {\n    padding: 0.8rem;\n    border-radius: 6px;\n    border: 1px solid #ddd;\n    font-size: 1rem;\n    font-family: inherit;\n}\n\n.save-custom-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    width: 100%;\n    padding: 0.8rem;\n    background: #FF9800;\n    /* Orange */\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-weight: normal;\n    cursor: pointer;\n    font-size: 1rem;\n    transition: background 0.2s;\n}\n\n.save-custom-btn:hover {\n    background: #F57C00;\n}\n\n.description {\n    margin-bottom: 2rem;\n    color: #666;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
